<template>
  <v-expansion-panels v-model="expanded" multiple>
    <v-expansion-panel
      :class="{ 'expanded-panel': expanded.includes(i) }"
      v-for="(cert, i) in items"
      :key="cert.id"
      v-model="expanded"
    >
      <v-expansion-panel-header>
        <div class="d-flex align-center justify-space-between w-100">
        <!-- Name with arrow if has children -->
        <div class="d-flex align-center" >
          <v-icon v-if="hasChildren(cert)"  > {{ expanded.includes(i) ? 'mdi-chevron-down' : 'mdi-menu-down' }}</v-icon>
          <span>{{ serverTranslate(cert.name) }}</span>
        </div>

          <v-spacer />

          <!-- Toggle icon with tooltip -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click.stop="cert.active = !cert.active"
                :color="cert.active =='1' ? 'success' : ''"
                large
              >
                {{ cert.active === '1'? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}
              </v-icon>
            </template>
            <span>{{ cert.active =='1' ? $t('DEACTIVATE') : $t('ACTIVATE') }}</span>
          </v-tooltip>
         </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content v-if="hasChildren(cert)">
        <!-- Recursively render sub-children -->
        <CertificatePanel :items="cert.children" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import serverTranslationsMixin from "@/mixins/serverTranslations";
import globalMethodsMixin from "@/mixins/globalMethods";

export default {
   name: "CertificatePanel",
  props: {
    items: Array
  },
  data() {
    return {
      expanded: []
    };
  },
   mixins: [serverTranslationsMixin,globalMethodsMixin],
  methods: {
    hasChildren(cert) {
      return cert.children && cert.children.length > 0;
    },


  },
};
</script>
